import { useTranslation } from 'react-i18next';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';
import faceClear from './examples/face-clear.png';
import sideView from './examples/side-view.png';
import faceOccluded from './examples/face-occluded.png';
import tooBlurry from './examples/too-blurry.png';
import multipleFaces from './examples/multiple-faces.png';
import faceTooLarge from './examples/too-large.png';

const examples = [
  { image: faceClear, textKey: 'avatar:guide.example.faceClear', isCorrect: true },
  { image: sideView, textKey: 'avatar:guide.example.side', isCorrect: false },
  { image: faceOccluded, textKey: 'avatar:guide.example.occluded', isCorrect: false },
  { image: tooBlurry, textKey: 'avatar:guide.example.tooBlurry', isCorrect: false },
  { image: multipleFaces, textKey: 'avatar:guide.example.multipleFaces', isCorrect: false },
  { image: faceTooLarge, textKey: 'avatar:guide.example.faceTooLarge', isCorrect: false },
];

export default function AvatarExamples() {
  const { t } = useTranslation('avatar');

  return (
    <div>
      <h4 className="text-gray-50 font-medium text-sm mb-3">
        {t('avatar:guide.examples', '示例')}
      </h4>
      <div className="grid grid-cols-3 gap-3">
        {examples.map((example, index) => (
          <div key={index} className="flex flex-col items-center">
            <div className="relative w-full aspect-[9/16] bg-bg-elevated rounded-lg overflow-hidden border border-border-subtle">
              <img
                src={example.image}
                alt={t(example.textKey)}
                className="w-full h-full object-cover"
              />
              <div className="absolute top-1 right-1">
                {example.isCorrect ? (
                  <CheckCircleIcon className="w-4 h-4 text-green-400" />
                ) : (
                  <XCircleIcon className="w-4 h-4 text-red-400" />
                )}
              </div>
            </div>
            <span className={`text-xs mt-1.5 ${example.isCorrect ? 'text-green-400' : 'text-red-400'}`}>
              {t(example.textKey)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
